export default __webpack_public_path__ + "static/ag-44b4ec5a7dcb540e6cb8650b07f79984.svg";